import { World } from '$legacyecstatic';
import { Components } from 'editor/components';
import React from 'react';

const defaultWorld = new World<Components>();

const ECSWorldContext = React.createContext<World<Components>>(defaultWorld);

export default ECSWorldContext;
